import { z } from "zod/v3";
import { PlanSchema } from "../generated/enums";

export const UPGRADE_REQUIRED_PREFIX = "UPGRADE_REQUIRED:";

export const UpgradeRequiredResourceSchema = z.enum(["members", "frameworks"]);

export const UpgradeRequiredPayloadSchema = z
  .object({
    resource: UpgradeRequiredResourceSchema,
    used: z.number().nonnegative(),
    max: z.union([z.literal(-1), z.number().nonnegative()]),
    plan: PlanSchema,
    message: z.string().min(1),
  })
  .strict();

export type UpgradeRequiredResource = z.infer<
  typeof UpgradeRequiredResourceSchema
>;
export type UpgradeRequiredPayload = z.infer<
  typeof UpgradeRequiredPayloadSchema
>;
